import React from 'react';
import { routeSteps } from '../../data/content';
import { SectionHeading } from '../SectionHeading';
import { CTAButton } from '../CTAButton';
export function RouteSteps() {
  return <section className="bg-brand-dark px-4 py-16 sm:py-24" aria-labelledby="route-title" data-id="element-239" data-mp="3kvm3xvmheb7m">
      <div className="mx-auto max-w-5xl" data-id="element-240" data-mp="3owxxudce1ilm">
        <SectionHeading eyebrow="The Route" title={<span id="route-title" data-id="element-242" data-mp="2s6xamiro3a6f">8 steps. One repeatable path for every case.</span>} subtitle="Know where you are in the process — and exactly what comes next." dark data-id="element-241" data-mp="3ovmswa77i4sx" />

        <ol className="relative mx-auto mt-12 grid max-w-md gap-0 md:max-w-none md:grid-cols-4 md:gap-4" data-id="element-243" data-mp="317lp1ekz3cju">
          {routeSteps.map((step, i) => <li key={step.title} className="relative flex gap-4 pb-6 md:flex-col md:gap-3 md:rounded-2xl md:bg-white/5 md:p-5 md:pb-5" data-id="element-244" data-mp="35zmv2irjs71f" data-mpi={i}>
              {i < routeSteps.length - 1 && <span className="absolute left-[23px] top-12 h-[calc(100%-3rem)] w-0.5 bg-brand-light/30 md:hidden" aria-hidden="true" data-id="element-245" data-mp="2dgg9l0iy2ma2" />}
              <span className="relative z-10 flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-white font-serif text-xl font-bold text-brand-dark" data-id="element-246" data-mp="3atsry3a044b3">
                {i + 1}
              </span>
              <div className="pt-1 md:pt-0" data-id="element-247" data-mp="31496qqytfyd2">
                <h3 className="text-lg font-extrabold uppercase tracking-wide text-white" data-id="element-248" data-mp="313g9qhpnsn84">{step.title}</h3>
                <p className="mt-1 text-[15px] leading-snug text-brand-light" data-id="element-249" data-mp="2w67qedsryd5a">{step.text}</p>
              </div>
            </li>)}
        </ol>

        <div className="mt-8" data-id="element-250" data-mp="2n3oqo2kacgn9">
          <CTAButton label="I want a clearer clinical route" data-id="element-251" data-mp="2n4zto05wpkdb" />
        </div>
      </div>
    </section>;
}